var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as Sentry from '@sentry/react';
import { CustomerType, } from '../types/_ProductSpecificTypes';
/**
 *
 * @param level Sentry defined Severity
 * @param message Free form text as the sentry event's message
 * @param ProductSpecificTags Product Specific tags
 * @param contexts Use as sentry context
 * @param tags Use as sentry tags to be merged with ProductSpecificTags
 * @returns sentry event id
 */
export var captureSentryEvent = function (level, message, _a, contexts, tags) {
    var productFamily = _a.productFamily, productWorkflow = _a.productWorkflow, customerType = _a.customerType;
    if (contexts === void 0) { contexts = {}; }
    if (tags === void 0) { tags = {}; }
    var mergedTags = __assign(__assign({}, tags), { productFamily: productFamily,
        productWorkflow: productWorkflow, customerType: customerType || CustomerType.UnknownCustomerType });
    return Sentry.captureEvent({
        message: message,
        level: level,
        contexts: contexts,
        tags: mergedTags,
    });
};
